export default __webpack_public_path__ + "static/media/bullrush_vid.d6467dd2.mp4";